module.exports = __webpack_public_path__ + "static/media/icon-file.758b8f3f.svg";